// Company name plus a red "connection expired" note when the QuickBooks
// link is dead (reports will fail for that company until it's reconnected)
function AccountLabel({ account }) {
  return (
    <>
      {account.companyName}
      {account.active === false && (
        <span style={{ color: "#dc2626", fontSize: "0.85em", marginLeft: "6px" }}>
          (connection expired)
        </span>
      )}
    </>
  );
}

function AccountSelector({
  accounts,
  //useAllAccounts,
  selectedAccounts,
  //onToggleAll,
  onSelect
}) {
  const allAccountIds = accounts.map((acc) => acc.accountId);

  const allSelected =
    accounts.length > 0 &&
    allAccountIds.every((id) => selectedAccounts.includes(id));

  // --- Build groups from account.groupName ---
  const groupsMap = accounts.reduce((map, acc) => {
    const g = acc.groupName;
    if (!g || g === "Ungrouped") return map;

    if (!map[g]) map[g] = [];
    map[g].push(acc);
    return map;
  }, {});

  // --- Individual accounts (no group) ---
  const individualAccounts = accounts.filter(
    (acc) => !acc.groupName || acc.groupName === "Ungrouped"
  );

  // --- Check/uncheck an entire group ---
  const toggleGroup = (groupName) => {
    const groupAccs = groupsMap[groupName];
    const groupIDs = groupAccs.map((a) => a.accountId);

    const groupAllSelected = groupIDs.every((id) =>
      selectedAccounts.includes(id)
    );

    if (groupAllSelected) {
      groupIDs.forEach((id) => {
        onSelect(id);
      });
    } else {
      groupIDs.forEach((id) => {
        if (!selectedAccounts.includes(id)) {
          onSelect(id);
        }
      });
    }
  };

  return (
    <div className="unified-box">
      <h3>Select Accounts</h3>

      <label style={{ display: "block", marginBottom: "10px" }}>
        <input
          type="checkbox"
          checked={allSelected}
          onChange={() => {
            if (allSelected) {
              allAccountIds.forEach((id) => {
                if (selectedAccounts.includes(id)) {
                  onSelect(id);
                }
              });
            } else {
              allAccountIds.forEach((id) => {
                if (!selectedAccounts.includes(id)) {
                  onSelect(id);
                }
              });
            }
          }}
        />
        {" "}
        All Accounts
      </label>

      {Object.keys(groupsMap).length > 0 && (
        <>
          <h4 style={{ marginTop: "20px", marginBottom: "8px" }}>
            Grouped Accounts
          </h4>

          {Object.keys(groupsMap).map((groupName) => {
            const groupAccs = groupsMap[groupName];
            const ids = groupAccs.map((a) => a.accountId);
            const groupAllSelected = ids.every((id) =>
              selectedAccounts.includes(id)
            );

            return (
              <div key={groupName} style={{ marginBottom: "10px" }}>
                <label style={{ fontWeight: 600 }}>
                  <input
                    type="checkbox"
                    checked={groupAllSelected}
                    onChange={() => toggleGroup(groupName)}
                  />
                  {" "}
                  {groupName}
                </label>

                <div style={{ marginLeft: "20px", marginTop: "6px" }}>
                  {groupAccs.map((acc) => (
                    <label
                      key={acc.accountId}
                      style={{ display: "block", marginBottom: "4px" }}
                    >
                      <input
                        type="checkbox"
                        checked={selectedAccounts.includes(acc.accountId)}
                        onChange={() => onSelect(acc.accountId)}
                      />
                      {" "}
                      <AccountLabel account={acc} />
                    </label>
                  ))}
                </div>
              </div>
            );
          })}
        </>
      )}

      {individualAccounts.length > 0 && (
        <>
          <h4 style={{ marginTop: "20px", marginBottom: "8px" }}>
            Individual Accounts
          </h4>

          {individualAccounts.map((acc) => (
            <label key={acc.accountId} style={{ display: "block" }}>
              <input
                type="checkbox"
                checked={selectedAccounts.includes(acc.accountId)}
                onChange={() => onSelect(acc.accountId)}
              />
              {" "}
              <AccountLabel account={acc} />
            </label>
          ))}
        </>
      )}
    </div>
  );
}

export default AccountSelector;